import { useQuery } from "@tanstack/react-query";
import { getAIReviewSettings, getAIReviewSettingDetail } from "../../api/bReviewsApi";

/**
 * Hook to get all AI review settings for an organisation
 */
export function useGetAISettings(organisationId) {
  return useQuery({
    queryKey: ["ai-review-settings", organisationId],
    queryFn: () => getAIReviewSettings(organisationId),
    enabled: !!organisationId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
}

/**
 * Hook to get a single AI review setting by ID
 */
export function useGetAISettingDetail(settingId, organisationId) {
  return useQuery({
    queryKey: ["ai-review-setting-detail", settingId, organisationId],
    queryFn: () => getAIReviewSettingDetail(settingId, organisationId),
    enabled: !!settingId && !!organisationId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
